export const toIDPrice = (price: number, withUnit?: boolean) => {
  const text = price.toLocaleString('id-ID');

  if (withUnit) {
    return ' Rp ' + text;
  } else {
    return text;
  }
};
